import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { Intersection } from '@splidejs/splide-extension-intersection';

export default {

	init() {
		console.log('init slider...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	bindEvents() {
		const elems = document.querySelectorAll('.splide.slider:not([data-splide-ignore])');

		if (elems.length) {
			elems.forEach(function (elem) {

				// Splide options
				let options = {};
				let defaults = {
					type: 'loop',
					perPage: 1,
					gap: '1.25rem',
					autoWidth: true,
					pagination: false,
					arrows: false,
					arrowPath: 'M9.01568 0.696967L8.9634 0.644714L8.91038 0.696187L7.7319 1.84026L7.6773 1.89329L7.73108 1.94711L13.8504 8.0664H0.750003H0.675003V8.1414V9.7839V9.8589H0.750003H13.8504L7.74833 15.961L7.6953 16.014L7.74833 16.067L8.90963 17.2283L8.96265 17.2813L9.01568 17.2283L17.2283 9.01567L17.2814 8.96265L17.2283 8.90963L9.01568 0.696967Z',
					trimSpace: true,
					mediaQuery: 'min',
					breakpoints: {
						1024: {
							gap: '1.5rem',
						}
					}
				};

				// Slider types
				let mobileOnly = false;
				let tickerStyle = false;

				// Assemble options for slider variations
				if(elem.classList.contains('is-slider-mobile')) {
					mobileOnly = true;
				}

				if(elem.classList.contains('is-slider-logo')) {
					tickerStyle = true;
					options.gap = '2.5rem';
					options.breakpoints = { 1024: { gap: '6.25rem' } }
					if(Number(elem.dataset.total) <= 4) {
						mobileOnly = true;
					}
				}

				if(elem.classList.contains('is-slider-gallery')) {
					tickerStyle = true;
				}

				if(elem.classList.contains('is-slider-team')) {
					tickerStyle = true;
				}

				if(elem.classList.contains('is-slider-quote')) {
					options.arrows = true;
					options.gap = '1.5rem';
					options.breakpoints = { 1024: { gap: '4rem' } }
				}

				if(mobileOnly) {
					options.breakpoints = { 768: { destroy: true } };
				}

				options = { ...defaults, ...options };

				// Initialize as ticker or standard carousel
				if(tickerStyle) {
					Sliders.initTicker(elem, options);
					return;
				}

				Sliders.initSlider(elem, options);
			});
		}
	},

	// Initialize a standard carousel
	initSlider(elem, options) {
		const slider = new Splide(elem, options);

		slider.mount();
	},

	// Initialize a ticker carousel
	initTicker(elem, options) {
		let tickerSpeed = 0.8;
		let tickerHoverSpeed = 0.2;

		if(elem.classList.contains('is-ticker-reverse')) {
			tickerSpeed = -tickerSpeed;
			tickerHoverSpeed = -tickerHoverSpeed;
		}

		// Autoscroll when in view
		options = { ...options, ...{
			focus: 'center',
			drag: 'free',
			autoScroll: {
				speed: tickerSpeed,
				autoStart: false,
				pauseOnHover: false,
				pauseOnFocus: false,
			},
			intersection: {
				inView: {
					autoScroll: true,
				},
				outView: {
					autoScroll: false,
				},
			},
		}};

		// Mount with extensions
		const slider = new Splide(elem, options);
		slider.on('ready', function() {
			Modal.bindModalEvents(); // Make sure cloned slides trigger modals
		});
		slider.mount({ AutoScroll, Intersection });

		// Custom hover behavior
		elem.addEventListener('mouseenter', function() {
			slider.options = {
				autoScroll: {
					speed: tickerHoverSpeed,
				}
			};
		});
		elem.addEventListener('mouseleave', function() {
			slider.options = {
				autoScroll: {
					speed: tickerSpeed,
				}
			};
		});

		// Custom play/pause control
		let button = elem.parentElement.querySelector('.is-slider-control');
		if(button) {
			button.addEventListener('click', function(e) {
				if(button.classList.contains('is-active')) {
					elem.classList.add('is-paused');
					slider.Components.AutoScroll.pause();
				} else {
					elem.classList.remove('is-paused');
					slider.Components.AutoScroll.play();
				}
			});
		}

		slider.on( 'intersection:in', function ( entry ) {
			if(elem.classList.contains('is-paused')) {
				slider.Components.AutoScroll.pause();
			}
		} );
	},

	toggleTicker(toggle) {
		const sliderControl = document.getElementById('slider-control');

		if(!sliderControl) {
			return;
		}

		if(toggle === 'pause' && !sliderControl.classList.contains('is-active')) {
			console.log('sliders: pausing');
			sliderControl.click();
			sliderControl.classList.add('is-should-resume');
		}

		if(toggle === 'play' && sliderControl.classList.contains('is-should-resume')) {
			console.log('sliders: playing');
			sliderControl.click();
			sliderControl.classList.remove('is-should-resume');
		}
	},

};